module.exports = __webpack_public_path__ + "img/FLY.98d9a232.png";